import React, { useState, useEffect } from "react";
import "./style.css";
import CreateAuto from "../CreateAuto";
import CreateProperty from "../CreateProperty";
import CreateUmbrella from "../CreateUmbrella";
import Modal from "react-modal";
import API from "../../utils/API";

const customStylesModal = {
  content: {
    padding: "10px 5px",
    backgroundImage: "linear-gradient(to top, #0ba360 0%, #3cba92 100%)",
    border: "0px",
    margin: "10px"
  }
};

function CreatePolicy({ clientID, clientFirstName, clientLastName, agents, rerender }) {
  const [formData, setFormData] = useState({
    showCreateAuto: false,
    showCreateProperty: false,
    showCreateUmbrella: false,
    clients: undefined,
    carrierData: undefined
  });

  useEffect(() => {
    API.getClients()
      .then((res) => {
        setFormData((prev) => ({ ...prev, clients: res.data }));
      })
      .catch((_err) => console.log(_err));

    API.getCarriers().then((res) => {
      setFormData((prev) => ({ ...prev, carrierData: res.data }));
    });
  }, []);

  const toggleCreateAuto = () => {
    if (formData.showCreateAuto === true) {
      setFormData((prev) => ({ ...prev, showCreateAuto: false }));
    } else {
      setFormData((prev) => ({
        ...prev,
        showCreateAuto: true,
        showCreateProperty: false,
        showCreateUmbrella: false
      }));
    }
  };

  const toggleCreateProperty = () => {
    if (formData.showCreateProperty === true) {
      setFormData((prev) => ({ ...prev, showCreateProperty: false }));
    } else {
      setFormData((prev) => ({
        ...prev,
        showCreateAuto: false,
        showCreateProperty: true,
        showCreateUmbrella: false
      }));
    }
  };

  const toggleCreateUmbrella = () => {
    if (formData.showCreateUmbrella === true) {
      setFormData((prev) => ({ ...prev, showCreateUmbrella: false }));
    } else {
      setFormData((prev) => ({
        ...prev,
        showCreateAuto: false,
        showCreateProperty: false,
        showCreateUmbrella: true
      }));
    }
  };

  return (
    <div>
      <div className="card-body">
        <div className="row">
          <div className="offset-md-4 col-md-4 btn btn-dark" onClick={toggleCreateAuto}>
            Create Vehicle Policy
          </div>
          {formData.showCreateAuto ? (
            <Modal
              isOpen={formData.showCreateAuto}
              onRequestClose={() => toggleCreateAuto()}
              style={customStylesModal}
            >
              <CreateAuto
                clientID={clientID}
                clientFirstName={clientFirstName}
                clientLastName={clientLastName}
                agents={agents}
                clients={formData.clients}
                carrierData={formData.carrierData}
                rerender={rerender}
              />
              <button
                style={{ width: "33%", marginLeft: "33%", textAlign: "center" }}
                onClick={() => toggleCreateAuto()}
              >
                Close
              </button>
            </Modal>
          ) : null}
          <div className="offset-md-4 col-md-4 btn btn-dark" onClick={toggleCreateProperty}>
            Create Property Policy
          </div>
          {formData.showCreateProperty ? (
            <Modal
              isOpen={formData.showCreateProperty}
              onRequestClose={() => toggleCreateProperty()}
              style={customStylesModal}
            >
              <CreateProperty
                clientID={clientID}
                clientFirstName={clientFirstName}
                clientLastName={clientLastName}
                agents={agents}
                clients={formData.clients}
                carrierData={formData.carrierData}
              />
              <button
                style={{ width: "33%", marginLeft: "33%", textAlign: "center" }}
                onClick={() => toggleCreateProperty()}
              >
                Close
              </button>
            </Modal>
          ) : null}
          <div className="offset-md-4 col-md-4 btn btn-dark" onClick={toggleCreateUmbrella}>
            Create Umbrella Policy
          </div>
          {formData.showCreateUmbrella ? (
            <Modal
              isOpen={formData.showCreateUmbrella}
              onRequestClose={() => toggleCreateUmbrella()}
              style={customStylesModal}
            >
              <CreateUmbrella
                clientID={clientID}
                clientFirstName={clientFirstName}
                clientLastName={clientLastName}
                agents={agents}
                clients={formData.clients}
                carrierData={formData.carrierData}
              />
              <button
                style={{ width: "33%", marginLeft: "33%", textAlign: "center" }}
                onClick={() => toggleCreateUmbrella()}
              >
                Close
              </button>
            </Modal>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default CreatePolicy;
